var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"winxian-container"},[_vm._l((_vm.itemList),function(item){return _c('HundredItem',{key:item.articleId,attrs:{"every":item,"curcer":item.articleId},on:{"itemClick":_vm.goDetail}})}),_c('Scroll',{attrs:{"scrollFlag":_vm.scrollFlag,"isEnd":_vm.isEnd}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }